export const DEFAULT_TOAST_DURATION = 5000;

export const DEFAULT_TOAST_POSITION = {
  top: 12,
  right: 12,
};
